import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  apiError: null
}

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.API_ERROR:
      return {
        ...state,
        apiError: action.payload
      }
    case actionTypes.CLEAR_ERRORS:
      return initialState
    default:
      return state
  }
}

export default errorReducer
